import { useEffect, useReducer, useState } from "react";
import { useDispatch } from "react-redux";
import { baseFetch } from "../helpers/apiClient";
import { toggleSessionModal } from "../redux/sessionSlice";

// Callers memoize the request so its identity represents the current filters.
export default function useDashboardList(request, token) {
  const dispatch = useDispatch();
  const [revision, refresh] = useReducer((value) => value + 1, 0);
  const [result, setResult] = useState({
    data: { results: [], total: 0 },
  });

  useEffect(() => {
    if (!token) return;
    const controller = new AbortController();

    baseFetch({ ...request, signal: controller.signal })
      .then((response) => {
        // Some responses can already be resolved when cleanup aborts the fetch.
        // Guard state updates as well as canceling the underlying request.
        if (controller.signal.aborted) return;
        setResult({ request, token, revision, data: response.data });
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        setResult((previous) => ({ ...previous, request, token, revision }));
        if (error === "Please authenticate") {
          dispatch(toggleSessionModal(false));
        }
      });

    return () => controller.abort();
  }, [dispatch, request, token, revision]);

  // Pending state follows the requested inputs immediately; an older response
  // cannot clear it, and starting a request needs no synchronous effect update.
  const loading =
    Boolean(token) &&
    (result.request !== request ||
      result.token !== token ||
      result.revision !== revision);

  return { data: result.data, loading, refresh };
}
